module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./echoes.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/echoes.md
// module id = 25
// module chunks = 6